import * as React from 'react';
import {connect} from 'react-redux';
import TabsModule from '../../Layout/TabsModule/TabsModule';
import Car from './Composites/Car';
import Alerts from './Composites/Alerts';
import History from './Composites/History';
import * as VehiclesModule from 'Modules/VehiclesModule';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import * as HistoryModule from 'Modules/HistoryModule';
import * as MapModule from 'Modules/MapModule';

export type Props = {
    history?: any;
};
export type State = {};
export type DispatchedProps = {
    setActiveCarDetailsView: (e: HistoryModule.EnumTypes.CarDetailsViewType) => void;
    setMapCenter: (center: MapModule.Types.MapCenter) => void
};
type ConnectedProps = {
    vehiclesStore: VehiclesModule.Types.VehiclesStore;
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
};

class CarDetails extends React.Component<Props & DispatchedProps & ConnectedProps, State> {
    constructor(props: Props & DispatchedProps & ConnectedProps) {
        super(props);
    }

    public render() {
        const {vehiclesStore, setActiveCarDetailsView, setMapCenter} = this.props;

        return (
            <>
                <TabsModule onChildrenClick={e => {
                    setActiveCarDetailsView(e);
                    if (e == HistoryModule.EnumTypes.CarDetailsViewType.CAR_DETAILS) {
                        try {
                            setMapCenter({
                                lat: vehiclesStore.activeVehicleDetails.latestDataframe.latitude,
                                lng: vehiclesStore.activeVehicleDetails.latestDataframe.longitude
                            });

                            // const mapPane = L.DomUtil.get('mainMap').querySelectorAll<HTMLInputElement>('.leaflet-map-pane')[0];
                            // L.DomUtil.setTransform(mapPane, L.point(0,0));
                        } catch (e) {
                            // do nothing
                            // console.log(e);
                        }
                    }
                }} carDetailsActiveEl={this.props.viewManagementStore.activeCarDetailsView}>
                    <Car title={'vehicle'} zone={HistoryModule.EnumTypes.CarDetailsViewType.CAR_DETAILS}/>
                    <History title={'passages'} disabled={vehiclesStore.singleCarViewData === null}
                             zone={HistoryModule.EnumTypes.CarDetailsViewType.HISTORY_RIDES}/>
                    <Alerts title={'alerts'} disabled={vehiclesStore.singleCarViewData === null}
                            history={this.props.history} zone={HistoryModule.EnumTypes.CarDetailsViewType.ALERTS}/>
                </TabsModule>
            </>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        viewManagementStore: state.viewManagementStore,
        vehiclesStore: state.vehiclesStore
    };
}

function mapDispachToProps(dispatch: any): DispatchedProps {
    return {
        setActiveCarDetailsView: (e: HistoryModule.EnumTypes.CarDetailsViewType) => dispatch(ViewManagementModule.Actions.setActiveCarDetailsView(e)),
        setMapCenter: (center: MapModule.Types.MapCenter) => dispatch(MapModule.Actions.setMapCenter(center))
    }
};

export default connect(
    mapStateToProps,
    mapDispachToProps
)(CarDetails);



// WEBPACK FOOTER //
// ./src/components/Map/CarDetails/CarDetails.tsx